// extracted by mini-css-extract-plugin
module.exports = {"power-backup-C":"StopsV2_power-backup-C___oLio"};